export default __webpack_public_path__ + "static/media/about.6de5ca36.png";